export const featuredComics = [
  {
    id: '1',
    title: '我的野蛮王妃',
    author: '朴素熙',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20drama%20illustration%2C%20elegant%20female%20character%20in%20traditional%20hanbok%20posing%20gracefully%2C%20soft%20pastel%20color%20palette%2C%20dreamy%20atmosphere%20with%20cherry%20blossom%20petals%2C%20manga%20art%20style%20with%20delicate%20linework%2C%20clean%20simple%20background%20with%20warm%20cream%20tones&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    category: '恋爱',
    status: '连载中',
    rating: 4.8,
    description: '现代女孩穿越到古代宫廷，与冷傲王子的命运交织...',
    latestChapter: '第128话',
    updateDate: '2026-07-03',
    views: 1280000,
    favorites: 35600,
    chapters: [
      { number: 128, title: '最后的抉择', date: '2026-07-03' },
      { number: 127, title: '意外重逢', date: '2026-07-02' },
      { number: 126, title: '王宫的阴谋', date: '2026-07-01' },
      { number: 125, title: '命运的转折', date: '2026-06-30' },
      { number: 124, title: '暗流涌动', date: '2026-06-29' },
      { number: 123, title: '新的开始', date: '2026-06-28' },
    ],
    comments: [
      { id: 'c1', user: '漫迷小丽', avatar: 'https://readdy.ai/api/search-image?query=cute%20anime%20style%20girl%20profile%20avatar%2C%20simple%20clean%20background%2C%20warm%20pink%20tones%2C%20manga%20art%20style%20headshot&width=100&height=100&seq=avatar-01&orientation=squarish', rating: 5, content: '这部漫画追了三年了，画风越来越精致，剧情也越来越精彩！每周都在等更新。', date: '2026-07-03' },
      { id: 'c2', user: '韩剧达人', avatar: 'https://readdy.ai/api/search-image?query=handsome%20anime%20style%20male%20profile%20avatar%2C%20simple%20clean%20background%2C%20cool%20blue%20tones%2C%20manga%20art%20style%20headshot&width=100&height=100&seq=avatar-02&orientation=squarish', rating: 4, content: '画师功力太强了，每个人物都很有特色，配角的塑造也很用心。', date: '2026-07-02' },
      { id: 'c3', user: '漫画控', avatar: 'https://readdy.ai/api/search-image?query=chibi%20anime%20style%20cat%20girl%20profile%20avatar%2C%20simple%20clean%20background%2C%20pastel%20yellow%20tones%2C%20manga%20art%20style%20headshot&width=100&height=100&seq=avatar-03&orientation=squarish', rating: 5, content: '太好看了！每一话都让人期待下一话，剧情节奏把握得太好了。', date: '2026-07-01' },
    ],
  },
  {
    id: '2',
    title: '剑与魔法',
    author: '金镇宇',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20action%20illustration%2C%20powerful%20warrior%20holding%20a%20glowing%20sword%2C%20epic%20battle%20scene%20with%20magical%20effects%2C%20dark%20dramatic%20lighting%2C%20manga%20art%20style%20with%20bold%20linework%2C%20simple%20clean%20background%20with%20dark%20gradient&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    category: '奇幻',
    status: '连载中',
    rating: 4.9,
    description: '在剑与魔法的异世界里，少年剑士踏上了复仇与成长的史诗征程...',
    latestChapter: '第215话',
    updateDate: '2026-07-03',
    views: 2350000,
    favorites: 89200,
    chapters: [
      { number: 215, title: '最终的决战', date: '2026-07-03' },
      { number: 214, title: '觉醒的力量', date: '2026-07-01' },
      { number: 213, title: '传承的意志', date: '2026-06-29' },
    ],
    comments: [],
  },
  {
    id: '3',
    title: '都市夜行',
    author: '郑允儿',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20modern%20urban%20noir%20illustration%2C%20stylish%20detective%20character%20in%20trench%20coat%20standing%20in%20rainy%20city%20street%20at%20night%2C%20neon%20light%20reflections%2C%20moody%20atmosphere%2C%20manga%20art%20style%2C%20clean%20simple%20background%20with%20dark%20blue%20tones&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    category: '悬疑',
    status: '已完结',
    rating: 4.7,
    description: '夜幕下的都市暗藏秘密，一位私家侦探揭开了惊人真相...',
    latestChapter: '第89话（终）',
    updateDate: '2026-06-15',
    views: 890000,
    favorites: 28500,
    chapters: [],
    comments: [],
  },
  {
    id: '4',
    title: '甜蜜契约',
    author: '李美妍',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20sweet%20romance%20illustration%2C%20cute%20couple%20characters%20holding%20hands%20in%20spring%20park%2C%20soft%20sunlight%20filtering%20through%20trees%2C%20gentle%20warm%20color%20palette%2C%20manga%20art%20style%20with%20soft%20linework%2C%20clean%20simple%20background%20with%20pastel%20green%20tones&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    category: '恋爱',
    status: '连载中',
    rating: 4.6,
    description: '一份意外的契约，让两个性格迥异的人走到了一起...',
    latestChapter: '第56话',
    updateDate: '2026-07-02',
    views: 650000,
    favorites: 18500,
    chapters: [],
    comments: [],
  },
  {
    id: '5',
    title: '武道至尊',
    author: '姜泰元',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20martial%20arts%20action%20illustration%2C%20fierce%20fighter%20in%20dynamic%20combat%20pose%20with%20energy%20aura%2C%20intense%20expression%2C%20dramatic%20lighting%20with%20warm%20orange%20accents%2C%20manga%20art%20style%2C%20clean%20simple%20background%20with%20warm%20beige%20tones&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    category: '动作',
    status: '连载中',
    rating: 4.8,
    description: '少年在武道世界一路披荆斩棘，成为至尊的传奇故事。',
    latestChapter: '第312话',
    updateDate: '2026-07-03',
    views: 3100000,
    favorites: 105000,
    chapters: [],
    comments: [],
  },
  {
    id: '6',
    title: '星之彼岸',
    author: '崔智媛',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20sci-fi%20fantasy%20illustration%2C%20beautiful%20female%20astronaut%20floating%20in%20starry%20space%2C%20galaxy%20nebula%20background%2C%20ethereal%20glowing%20effects%2C%20dreamy%20atmosphere%2C%20manga%20art%20style%2C%20clean%20simple%20background%20with%20deep%20space%20tones&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    category: '科幻',
    status: '连载中',
    rating: 4.5,
    description: '地球毁灭后，人类在宇宙中寻找新的家园...',
    latestChapter: '第78话',
    updateDate: '2026-07-01',
    views: 520000,
    favorites: 14200,
    chapters: [],
    comments: [],
  },
];

export const heroComics = [
  featuredComics[0],
  featuredComics[1],
  featuredComics[4],
];

export const latestUpdates = [
  { ...featuredComics[0], updatedAt: '2小时前' },
  { ...featuredComics[4], updatedAt: '3小时前' },
  { ...featuredComics[1], updatedAt: '5小时前' },
  { ...featuredComics[3], updatedAt: '6小时前' },
  { ...featuredComics[5], updatedAt: '8小时前' },
  { ...featuredComics[2], updatedAt: '15天前' },
];

export const categories = [
  { id: 'love', name: '恋爱漫画', icon: 'ri-heart-line', count: 1200, description: '甜蜜浪漫的爱情故事，少女心满满', color: 'from-pink-500/20 to-rose-500/30' },
  { id: 'action', name: '动作漫画', icon: 'ri-sword-line', count: 980, description: '热血激燃的战斗场面，肾上腺素飙升', color: 'from-orange-500/20 to-red-500/30' },
  { id: 'fantasy', name: '奇幻漫画', icon: 'ri-magic-line', count: 850, description: '魔法与冒险交织的异世界之旅', color: 'from-purple-500/20 to-indigo-500/30' },
  { id: 'suspense', name: '悬疑漫画', icon: 'ri-search-eye-line', count: 620, description: '烧脑推理与惊悚悬疑的完美融合', color: 'from-slate-500/20 to-gray-500/30' },
  { id: 'sf', name: '科幻漫画', icon: 'ri-rocket-line', count: 450, description: '未来科技与宇宙探索的无限畅想', color: 'from-cyan-500/20 to-blue-500/30' },
  { id: 'comedy', name: '搞笑漫画', icon: 'ri-emotion-laugh-line', count: 780, description: '轻松搞笑的日常喜剧，笑到停不下来', color: 'from-yellow-500/20 to-amber-500/30' },
  { id: 'horror', name: '恐怖漫画', icon: 'ri-ghost-line', count: 340, description: '惊悚恐怖的悬疑故事，胆大你就来', color: 'from-red-500/20 to-black/30' },
  { id: 'daily', name: '日常漫画', icon: 'ri-calendar-line', count: 560, description: '温馨治愈的日常生活点滴', color: 'from-green-500/20 to-emerald-500/30' },
];

export const testimonials = [
  {
    id: 't1',
    name: '王小明',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20male%20portrait%20photography%2C%20young%20chinese%20man%20smiling%20warmly%2C%20studio%20lighting%2C%20clean%20simple%20background%2C%20natural%20expression%2C%20high%20quality%20headshot&width=200&height=200&seq=testimonial-01&orientation=squarish',
    level: 'VIP会员',
    content: '作为一个追了十年漫画的老读者，韩漫大全真的是我用过最舒服的平台。更新速度超快，基本上韩国那边一出我们这边就有了。画质也很高清，手机上看一点都不糊，强烈推荐！',
    rating: 5,
  },
  {
    id: 't2',
    name: '李婷婷',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20female%20portrait%20photography%2C%20young%20chinese%20woman%20with%20warm%20smile%2C%20studio%20lighting%2C%20clean%20simple%20background%2C%20natural%20expression%2C%20high%20quality%20headshot&width=200&height=200&seq=testimonial-02&orientation=squarish',
    level: '资深读者',
    content: '评论区氛围特别好！每次看完一话都忍不住去评论区跟大家一起讨论剧情。编辑推荐也很有眼光，通过推荐发现了好多宝藏漫画。',
    rating: 5,
  },
  {
    id: 't3',
    name: '张伟',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20male%20portrait%20photography%2C%20young%20chinese%20man%20with%20casual%20smile%2C%20studio%20lighting%2C%20clean%20simple%20background%2C%20natural%20expression%2C%20high%20quality%20headshot&width=200&height=200&seq=testimonial-03&orientation=squarish',
    level: '白金会员',
    content: '收藏功能太方便了，追的二十几部漫画都能一键追踪。每天打开APP就能看到哪些更新了，再也不用一个个去找了。界面也很清爽，没有乱七八糟的广告。',
    rating: 5,
  },
];

export const faqs = [
  { question: '韩漫大全是否完全免费？', answer: '是的！韩漫大全平台上所有漫画均可免费在线阅读，无需支付任何费用。我们致力于为广大漫画爱好者提供优质的免费韩漫阅读服务。' },
  { question: '每天更新多少部漫画？', answer: '我们每天更新超过50部热门韩漫的最新章节，确保读者能够第一时间追到自己喜欢漫画的最新内容。更新时间通常为韩国发布后2小时内。' },
  { question: '如何收藏我喜欢的漫画？', answer: '在漫画详情页点击「加入收藏」按钮即可将漫画添加到您的收藏夹。收藏后，该漫画更新时您会收到提醒通知，方便随时追更。' },
  { question: '支持哪些设备阅读？', answer: '韩漫大全完美适配手机、平板和电脑端。无论您使用什么设备，都能获得流畅舒适的阅读体验。手机端支持上下滑动和左右翻页两种模式。' },
  { question: '可以离线下载漫画吗？', answer: '目前我们正在开发离线下载功能，预计将在下一版本中上线。届时会员可以下载漫画离线阅读，敬请期待！' },
  { question: '如何联系客服？', answer: '您可以通过关于我们页面的联系表单发送消息，或发送邮件至 hello@knn08.com。我们的客服团队会在24小时内回复您的咨询。' },
];

export const siteStats = {
  totalComics: 50000,
  totalUsers: 10000000,
  dailyUpdates: 50,
  avgRating: 4.7,
};